
import { useState,useEffect } from "react";
import {Button} from 'antd';

const SPCountDownButton = ({countDownTime,text,onClick,disabled = false}:any) => {
const [time, setCount] = useState(countDownTime)

  // useEffect(() => {
    let times = time;
    let timer = setInterval(function () {
    if (times < 1) {
      setCount(0)
      clearInterval(timer);
    } else {
      times -= 1;
      setCount(times);
    }
  }, 1000);
  // },[])

return (
  <>
    <Button type='primary' disabled={disabled && time > 0} onClick={onClick}>{time > 0 ? time+'秒后可操作':'我已知晓'}</Button>
  </>
);
}

export default SPCountDownButton;


